import type { Dayjs } from 'dayjs'

export const toFullDayIsoRange = (
    values: [Dayjs | null, Dayjs | null] | null
): [string, string] | null => {
    if (!values?.[0] || !values[1]) {
        return null
    }
    return [
        values[0].startOf('day').toISOString(),
        values[1].endOf('day').toISOString(),
    ]
}
